import { Verification } from '../lib/types'
export const BASE_URL = process.env.REACT_APP_GBC_BASE_URL || 'http://0.0.0.0:4000'
export const SIGN_OUT = `${BASE_URL}/auth/logout`
export const RESET_PASSWORD_TOKEN_VALID = (code: string, userId: string) =>
  `${BASE_URL}/v1/user/reset-password/token/validate?code=${code}&userId=${userId}`
export const UPLOAD_FILE = `${BASE_URL}/file/upload`
export const UPLOAD_PUBLIC_FILE = `${BASE_URL}/file/public/upload`
export const GET_PROJECT_BY_ID = `${BASE_URL}/project`
export const SEARCH_PROJECTS = `${BASE_URL}/project/search`
export const SAVED_FOR_LATER = `${BASE_URL}/project/save`
export const GET_ALL_PROJECTS = `${BASE_URL}/project/all`
export const KYC_SUBMIT = `${BASE_URL}/kyc/submit`
export const KYC_UPDATE = `${BASE_URL}/kyc/update`
export const GET_KYC = (id: string) => `${BASE_URL}/kyc/${id}`
export const CONTACT_US_SUBMIT = `${BASE_URL}/contact-us/submit`
export const LOGGED_IN_USER = `${BASE_URL}/logged-in-user`
export const UPDATE_KYC_DOCUMENT = (id: string) => `${BASE_URL}/kyc/document/${id}/update`
export const ACCEPT_NDA = `${BASE_URL}/kyc/accept-nda`
export const HOME = `${BASE_URL}/home`
export const GENERATE_SUMSUB_ACCESS_TOKEN = `${BASE_URL}/v1/kyc/sumsub/generate/auth-token`
export const GENERATE_SUMSUB_SDK_LINK = `${BASE_URL}/v1/kyc/sumsub/generate/sdk-link`

export const GET_INVESTMENT_BY_PROJECT_ID = `${BASE_URL}/investments`
export const POST_PROJECT_INVESTMENT = `${BASE_URL}/investments/invest`
export const UPDATE_PROJECT_INVESTMENT = `${BASE_URL}/investments/update`
export const GET_USER_INVESTMENT = `${BASE_URL}/investments/user/details`
export const SEARCH_INVESTMENTS = `${BASE_URL}/investments/search`
export const GET_INVESTMENT_METRICS = `${BASE_URL}/investments/metrics`
export const GET_QUARTERLY_REPORT = `${BASE_URL}/investments/quaterly-reports`
export const PREVIEW_FILE = `${BASE_URL}/file/preview`
export const GET_INVESTMENT_LATEST = `${BASE_URL}/investments/latest`

export const GET_FEATURED_PROJECT = `${BASE_URL}/project/featured`
export const GET_LAST_MINUTE_PROJECTS = `${BASE_URL}/project/lastminute`

// v1 routes
export const USER_CREATE_V1 = `${BASE_URL}/v1/user/signup`
export const PROMOTE_SIGNUP_V1 = `${BASE_URL}/v1/user/promote-signup`
export const PROMOTE_SIGNUP_DIRECT_V1 = `${BASE_URL}/v1/user/promote-signup/direct`
export const PROMOTE_SIGNUP_MAGIC_V1 = `${BASE_URL}/v1/user/promote-signup/magic`
export const SET_OWN_PASSWORD_V1 = `${BASE_URL}/v1/user/set-password`
export const PROMOTE_SIGNUP_EMAIL_V1 = `${BASE_URL}/v1/user/promote-signup/email`
export const EMAIL_LINK_LOGIN_V1 = `${BASE_URL}/v1/user/login/email-link`
export const PHONE_OTP_LOGIN_REQUEST_V1 = `${BASE_URL}/v1/user/login/phone-otp/request`
export const PHONE_OTP_LOGIN_VERIFY_V1 = `${BASE_URL}/v1/user/login/phone-otp/verify`
export const PROMOTE_SIGNUP_TOKEN_VALID = (code: string, userId: string) =>
  `${BASE_URL}/v1/user/promote-signup/token/validate?code=${code}&userId=${userId}`
export const PROMOTE_SIGNUP_COMPLETE_V1 = `${BASE_URL}/v1/user/promote-signup/complete`
export const VERIFY_EMAIL_V1 = (code: string, investorId: string, type: Verification) =>
  `${BASE_URL}/v1/user/verify-email?investorId=${investorId}&code=${code}&type=${type}`
export const SEND_VERIFICATION_LINK_V1 = `${BASE_URL}/v1/user/resend/verify-email`
export const RESET_PASSWORD_V1 = `${BASE_URL}/v1/user/reset-password`
export const USER_SIGN_IN_V1 = `${BASE_URL}/v1/auth/login`
export const USER_LOGOUT_V1 = `${BASE_URL}/v1/auth/logout`
export const ADMIN_INVESTOR_SIGN_IN_V1 = `${BASE_URL}/v1/auth/admin-investor-login`
export const GET_ALL_OPPORTUNITY = `${BASE_URL}/v1/opportunity/all`
export const SEARCH_OPPORTUNITY_V1 = `${BASE_URL}/v1/opportunity/search`
export const ACCEPT_NDA_V1 = `${BASE_URL}/v1/kyc/accept-nda`
export const ACCEPT_INVESTMENT_ESSENTIAL_AGREEMENT = `${BASE_URL}/v1/kyc/accept-investment-essentials-agreement`
export const ACCEPT_TOB = `${BASE_URL}/v1/kyc/accept-tob`
export const ACCEPT_TRANSACTION_CHECKLIST_AGREEMENT = `${BASE_URL}/v1/kyc/accept-transaction-checklist-agreement`
export const SUBMIT_CLIENT_AGREEMENT = `${BASE_URL}/v1/kyc/submit-client-agreement`
export const ACKNOWLEDGE_MARKED_DORMANT_MODAL = `${BASE_URL}/v1/kyc/dormancy-acknowledgment`
export const ACCEPT_INVESTOR_DORMANCY_REMINDER = `${BASE_URL}/v1/kyc/accept-dormancy-reminder`
export const GET_OPPORTUNITY_BY_ID = (id: string) => `${BASE_URL}/v1/opportunity/${id}`
export const POST_OPPORTUNITY_WHATSAPP = (opportunityId: number) =>
  `${BASE_URL}/v1/opportunity/${opportunityId}/support-request`
export const GET_OPPORTUNITY_BY_SLUG_AND_TOKEN = (slug: string, token: string) =>
  `${BASE_URL}/v1/opportunity/link/${slug}?access=${token}`
export const GET_MARKETING_SIGNUP_LANDING = (slug: string) =>
  `${BASE_URL}/v1/opportunity/signup-landing/${slug}`
export const GET_KYC_V1 = (id: string) => `${BASE_URL}/v1/kyc/${id}`
export const GET_USER_INVESTMENT_V1 = `${BASE_URL}/v1/investments/investor`
export const GET_INVESTMENT_LATEST_V1 = `${BASE_URL}/v1/investments/latest`
export const GET_INVESTMENT_BY_OPPORTUNITY_ID = `${BASE_URL}/v1/investments`
export const LOGGED_IN_USER_V1 = `${BASE_URL}/v1/logged-in-user`
export const GET_PROFILE_V1 = `${BASE_URL}/v1/logged-in-user`
export const ADD_OPPORTUNITY_INVESTMENT = `${BASE_URL}/v1/investments`
export const UPDATE_OPPORTUNITY_INVESTMENT = `${BASE_URL}/v1/investments`
export const NOTIFY_INSUFFICIENT_BALANCE = (investmentId: number) =>
  `${BASE_URL}/v1/investments/${investmentId}/insufficient-balance-notice`
export const UPDATE_PROFILE_V1 = `${BASE_URL}/v1/user`
export const SEARCH_INVESTMENTS_V1 = `${BASE_URL}/v1/investments/search`
export const GET_INVESTMENT_METRICS_V1 = `${BASE_URL}/v1/investments/metrics`
export const GET_SIGNED_CLIENT_AGREEMENT_DOCUMENT = `${BASE_URL}/v1/investments/signed-document` //no need
export const GET_SIGNED_TERMSHEET_AGREEMENT_DOCUMENT = `${BASE_URL}/v1/investments/termsheet-agreement`
export const GET_INVESTMENT_FEE_SUMMARY = `${BASE_URL}/v1/investments/investment-summary`
export const SIGN_TERMSHEET_AGREEMENT_DOCUMENT = `${BASE_URL}/v1/investments/termsheet-agreement`
export const GET_DOCUMENT_ACCESS_TOKEN = `${BASE_URL}/v1/documents/access-token`
export const GET_DOCUMENT_SIGNING_LINK = `${BASE_URL}/v1/documents/signing-link`
export const GET_DOCUMENT_DOWNLOAD_LINK = `${BASE_URL}/v1/documents/download-link`
export const GET_TERMSHEET_AGREEMENT_TEMPLATE = (
  opportunityId: string,
  investmentAmount: string,
  investmentId: string,
) =>
  `${BASE_URL}/v1/documents/termsheet-agreement?opportunityId=${opportunityId}&investmentAmount=${investmentAmount}&investmentId=${investmentId}`
export const CREATE_TERMSHEET_SIGNING_LINK = `${BASE_URL}/v1/documents/termsheet-agreement/signing-link`
export const CONTACT_US_INVESTOR_SUBMIT_V1 = `${BASE_URL}/v1/contact-us/submit`
export const CONTACT_US_GUEST_SUBMIT_V1 = `${BASE_URL}/v1/contact-us/guest/submit`
export const BUSINESS_CONTACT_SUBMIT = `${BASE_URL}/v1/contact-us/business/submit`
export const GET_INVESTOR_WITH_KYC = `${BASE_URL}/v1/kyc/investor-with-kyc`
export const GOOGLE_SIGN_IN_V1 = `${BASE_URL}/v1/auth/login-with-google`
export const GET_FEATURED_OPPORTUNITY = `${BASE_URL}/v1/opportunity/featured`
export const GET_COMING_SOON_OPPORTUNITIES = `${BASE_URL}/v1/coming-soon-opportunities`
export const GET_ASSET_CLASSES = `${BASE_URL}/v1/opportunity/asset-classes`
export const UPDATE_CRM = `${BASE_URL}/v1/crm/update`
export const ADD_CRM_EVENT = `${BASE_URL}/v1/crm/event`
export const AUDIT_EVENTS = `${BASE_URL}/v1/audit/events`
export const AUDIT_EVENTS_BATCH = `${BASE_URL}/v1/audit/events/batch`
export const AUDIT_EVENTS_PUBLIC = `${BASE_URL}/v1/audit/events/public`
export const GET_DASHBOARD_SUMMARY = `${BASE_URL}/v1/dashboard/summary`
export const GET_INVESTMENT_SUMMARY = (opportunityId: string) =>
  `${BASE_URL}/v1/dashboard/summary/${opportunityId}`
export const GET_DASHBOARD_INVESTOR_HOLDINGS = `${BASE_URL}/v1/dashboard/holdings`
export const GET_DASHBOARD_ACTIVE_INVESTMENTS = `${BASE_URL}/v1/dashboard/investments/active`
export const GET_DASHBOARD_ACTIVE_INVESTMENTS_BY_OPPORTUNITY_ID = (opportunityId: string) =>
  `${BASE_URL}/v1/dashboard/investments/active/${opportunityId}`
export const GET_DASHBOARD_TRANSACTIONS_BY_OPPORTUNITY_ID = (opportunityId: string) =>
  `${BASE_URL}/v1/transaction/${opportunityId}`
export const GET_PORTFOLIO_STATEMENTS = `${BASE_URL}/v1/portfolio-statements`
export const GET_PORTFOLIO_STATEMENT_DOWNLOAD = (id: string) =>
  `${BASE_URL}/v1/portfolio-statements/${id}/download`
export const GET_MAX_WITHDRAWAL_AMOUNT_FOR_OPPORTUNITY = (opportunityId: string) =>
  `${BASE_URL}/v1/withdrawals/max-amount/${opportunityId}`
export const GET_MAX_WITHDRAWAL_UNITS_FOR_OPPORTUNITY = (opportunityId: string) =>
  `${BASE_URL}/v1/withdrawals/max-units/${opportunityId}`

export const ADD_WITHDRAWAL = `${BASE_URL}/v1/withdrawals`
export const GET_ACTIVE_WITHDRAWAL_REQUEST_FOR_OPPORTUNITY = (
  investorId: string,
  opportunityId: string,
) => `${BASE_URL}/v1/withdrawals/investor/${investorId}/opportunity/${opportunityId}`
export const UPDATE_OPPORTUNITY_WITHDRAWAL = (withdrawalId: number) =>
  `${BASE_URL}/v1/withdrawals/${withdrawalId}/update-withdrawal`
export const SEARCH_WITHDRAWALS = `${BASE_URL}/v1/withdrawals/search`

export const SECONDARY_MARKET_PORTAL = `${BASE_URL}/v1/secondary-market/portal`
export const SECONDARY_MARKET_SELL = `${BASE_URL}/v1/secondary-market/orders/sell`
export const SECONDARY_MARKET_BUY_INTEREST = `${BASE_URL}/v1/secondary-market/orders/buy-interest`
export const SECONDARY_MARKET_CANCEL_ORDER = (orderId: number | string) =>
  `${BASE_URL}/v1/secondary-market/orders/${orderId}/cancel`

export const GET_INVESTOR_BANK_DETAILS = (investorId: string) =>
  `${BASE_URL}/v1/kyc/bank-details/${investorId}`
export const GET_INVESTOR_DORMANCY_REMINDER_DETAILS = `${BASE_URL}/v1/user-dormancy-details`
export const EXTEND_INVESTMENT_LIMIT = `${BASE_URL}/v1/kyc/extend-limit`
export const GET_MY_INVESTMENT_LIMIT_REQUEST = `${BASE_URL}/v1/kyc/investment-limit-requests/mine`
export const ONBOARDING_BANK_STATEMENTS = `${BASE_URL}/v1/kyc/onboarding-bank-statements`
export const GET_MY_ONBOARDING_BANK_STATEMENTS = `${BASE_URL}/v1/kyc/onboarding-bank-statements/mine`
export const OPPORTUNITY_INTEREST = `${BASE_URL}/v1/opportunity-interest`
export const OPPORTUNITY_ALLOCATION_INTEREST = (opportunityId: number | string) =>
  `${BASE_URL}/v1/opportunity/${opportunityId}/interest`
export const UPDATE_INVESTOR_BANK_DETAILS = `${BASE_URL}/v1/kyc/bank-details`
export const GET_INVESTOR_KYC_DOCUMENTS_CHECKLIST = (investorId: string) =>
  `${BASE_URL}/v1/kyc/documents-checklist/${investorId}`
export const GET_SUMSUB_DOCUMENT = (investorId: string, documentId: string) =>
  `${BASE_URL}/v1/kyc/sumsub/${investorId}/document-file/${documentId}`
export const GET_INVESTOR_PORTFOLIO_IDS = (investorId: string) =>
  `${BASE_URL}/v1/kyc/investor/${investorId}/portfolio-ids`

export const GET_SIGNED_SELF_DECLARATION_DOCUMENT = `${BASE_URL}/v1/kyc/signed-document`
export const CHECK_SELF_DECLARATION_REQUIRED = `${BASE_URL}/v1/kyc/self-declaration-required`

export const GENERATE_PHONE_OTP = `${BASE_URL}/v1/user/generate-phone-otp`
export const VERIFY_PHONE_OTP = `${BASE_URL}/v1/user/verify-phone-otp`
export const GET_WITHDRAWAL_APPROVAL_DETAILS = (withdrawalId: string) =>
  `${BASE_URL}/v1/withdrawals/${withdrawalId}/approval-details`
export const GET_WITHDRAWAL_PREDICT_APPROVAL_DETAILS = (opportunityId: string, amount: string) =>
  `${BASE_URL}/v1/withdrawals/predict-approval-details/${opportunityId}/${amount}`
export const GET_WITHDRAWAL_PREDICT_APPROVAL_DETAILS_UNITS = (
  opportunityId: string,
  quantity: string,
) => `${BASE_URL}/v1/withdrawals/predict-approval-details/${opportunityId}/units/${quantity}`
export const WHATS_APP_SUPPORT = `${BASE_URL}/v1/whats-app-support/start-whats-app-support`

export const GET_BLOG_POSTS = `${BASE_URL}/v1/blog/posts`
export const GET_BLOG_POST_BY_SLUG = (slug: string) => `${BASE_URL}/v1/blog/posts/${slug}`

export const GET_WEBINARS = `${BASE_URL}/v1/webinars`

// Newsletter
export const SUBSCRIBE_TO_NEWSLETTER = `${BASE_URL}/v1/newsletter/subscribe`
export const UNSUBSCRIBE_FROM_NEWSLETTER = `${BASE_URL}/v1/newsletter/unsubscribe`
export const GET_NEWSLETTER_SUBSCRIBER_DETAILS = `${BASE_URL}/v1/newsletter/subscriber`

// FAQs (public list; optional auth attaches JWT if present)
export const GET_FAQS_V1 = `${BASE_URL}/v1/faqs`

export const GET_WALLET_V1 = `${BASE_URL}/v1/wallet`
export const WALLET_TOPUPS_V1 = `${BASE_URL}/v1/wallet/topups`
export const WALLET_TOPUP_V1 = (id: number | string) => `${BASE_URL}/v1/wallet/topups/${id}`
export const WALLET_WITHDRAWALS_V1 = `${BASE_URL}/v1/wallet/withdrawals`
export const WALLET_WITHDRAWAL_V1 = (id: number | string) =>
  `${BASE_URL}/v1/wallet/withdrawals/${id}`

export const PARTNER_LOGIN = `${BASE_URL}/v1/partner/auth/login`
export const PARTNER_SET_PASSWORD = `${BASE_URL}/v1/partner/auth/reset-password`
export const PARTNER_LOGOUT = `${BASE_URL}/v1/partner/auth/logout`
export const PARTNER_INVESTORS = `${BASE_URL}/v1/partner/investors`
export const TRADING_ACCOUNT_V1 = `${BASE_URL}/v1/trading/account`
export const TRADING_ASSET_V1 = (symbol: string) => `${BASE_URL}/v1/trading/assets/${symbol}`
export const TRADING_QUOTES_V1 = `${BASE_URL}/v1/trading/quotes`
export const TRADING_ORDERS_V1 = `${BASE_URL}/v1/trading/orders`
export const TRADING_ORDER_V1 = (id: string) => `${BASE_URL}/v1/trading/orders/${id}`
export const TRADING_POSITIONS_V1 = `${BASE_URL}/v1/trading/positions`
export const TRADING_FUND_FROM_WALLET_V1 = `${BASE_URL}/v1/trading/funding/from-wallet`
export const TRADING_WITHDRAW_TO_WALLET_V1 = `${BASE_URL}/v1/trading/funding/to-wallet`
export const TRADING_CANCEL_TRANSFER_V1 = (alpacaJournalId: string) =>
  `${BASE_URL}/v1/trading/funding/transfers/${encodeURIComponent(alpacaJournalId)}/cancel`
export const TRADING_CHAT_V1 = `${BASE_URL}/v1/trading/chat`
export const TRADING_WALLET_V1 = `${BASE_URL}/v1/trading/wallet`
export const TRADING_ASSET_SEARCH_V1 = `${BASE_URL}/v1/trading/assets/search`
export const TRADING_ASSET_OVERVIEW_V1 = (symbol: string) =>
  `${BASE_URL}/v1/trading/assets/${encodeURIComponent(symbol)}/overview`
export const TRADING_ASSET_BARS_V1 = (symbol: string) =>
  `${BASE_URL}/v1/trading/assets/${encodeURIComponent(symbol)}/bars`
export const TRADING_ORDER_PREVIEW_V1 = `${BASE_URL}/v1/trading/orders/preview`
export const TRADING_MARKET_STATUS_V1 = `${BASE_URL}/v1/trading/market/status`
export const TRADING_PORTFOLIO_V1 = `${BASE_URL}/v1/trading/portfolio`
export const TRADING_PORTFOLIO_HISTORY_V1 = `${BASE_URL}/v1/trading/portfolio/history`
